module.exports = __webpack_public_path__ + "static/media/dark-logo.7d3999d3.svg";